export default __webpack_public_path__ + "static/media/ReportsGreyIcon.63d6a27d.svg";